module.exports = __webpack_public_path__ + "img/gth_gbt1973_2_1989_left.prt.ebdd8026.jpg";